<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="">
          <div class="card-body">
            <div class="card-body-form">
              <div v-if="allModify" class="page-transparent-bg"></div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>媒体号名称</label>
                    <input
                      v-model="media.name"
                      type="text"
                      class="form-control"
                      maxlength="16"
                      placeholder="请输入2-16个字符"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>手机</label>
                    <input
                      v-model="media.phone"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div class="row" v-if="!isEdit">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>密码</label>
                    <input
                      v-model="media.password"
                      type="password"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row" v-if="!isEdit">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>重复密码</label>
                    <input
                      v-model="media.repeatPassword"
                      type="password"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>认证名称</label>
                    <input
                      v-model="media.cerName"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>媒体号简介</label>
                    <input
                      v-model="media.description"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>运营主体/姓名</label>
                    <input
                      v-model="media.operateBody"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>统一社会信用代码/身份证号</label>
                    <input
                      v-model="media.creditCode"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>运营</label>
                    <div class="dsply-fix">
                      <!-- <b-form-checkbox
                        class="m-r-30"
                        v-for="item in operateSet"
                        :key="item.key"
                        v-model="choiceOperateSet"
                        :value="item.key"
                        checked
                        plain
                        >{{ item.text }}</b-form-checkbox
                      > -->
                      <div class="operate-input-item">
                        <span class="pull-left">关注数</span>
                        <input
                          v-model="media.operateFollowNum"
                          type="text"
                          class="form-control"
                          placeholder="数字"
                        />
                      </div>
                      <div class="operate-input-item">
                        <span class="pull-left">点赞数</span>
                        <input
                          v-model="media.operateLikeNum"
                          type="text"
                          class="form-control"
                          placeholder="数字"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>账号类型</label>
                    <div>
                      <el-radio v-model="media.type" :label="1"
                        >汉新闻号</el-radio
                      >
                      <el-radio v-model="media.type" :label="2"
                        >记者/供稿单位</el-radio
                      >
                      <el-radio v-model="media.type" :label="3"
                        >广电矩阵</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>认证类型</label>
                    <div>
                      <el-radio v-model="media.cerType" :label="1"
                        >个人</el-radio
                      >
                      <el-radio v-model="media.cerType" :label="2"
                        >企业</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>免审开关</label>
                    <div>
                      <el-radio disabled v-model="media.verifyFlag" :label="0"
                        >关闭</el-radio
                      >
                      <el-radio disabled v-model="media.verifyFlag" :label="1"
                        >开启</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label>头像</label>
                    <image-upload
                      size="1:1"
                      ref="avatar"
                      v-model="media.avatar"
                    ></image-upload>
                    <div style="color: #aaa; margin-top: 5px">
                      图片比例 1:1，建议尺寸 200 * 200 px
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-9">
                  <div class="mb-3">
                    <label>认证材料上传</label>
                    <div style="display: flex">
                      <div>
                        <image-upload
                          size="1:1"
                          v-model="img1"
                          :isShowDel="!allModify && verifyState !== 3"
                        ></image-upload>
                      </div>
                      <div style="margin-left: 10px">
                        <image-upload
                          size="1:1"
                          v-model="img2"
                          :isShowDel="!allModify && verifyState !== 3"
                        ></image-upload>
                      </div>
                      <div style="margin-left: 10px">
                        <image-upload
                          size="1:1"
                          v-model="img3"
                          :isShowDel="!allModify && verifyState !== 3"
                        ></image-upload>
                      </div>
                    </div>
                    <div style="color: #aaa; margin-top: 5px">
                      个人用户请上传手持身份证正面半身照片以及身份证正反面照片，企业用户请上传营业执照扫描件
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label>主页封面图</label>
                    <image-upload ref="cover"></image-upload>
                  </div>
                </div>
              </div> -->
            </div>

            <div class="row submit-bar" style="height: 80px">
              <div class="col-md-12">
                <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
                <div class="bar-handle" v-if="!allModify">
                  <!-- <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button> -->
                  <button
                    @click="submitPreserve"
                    class="btn-sm btn btn-primary"
                    type="button"
                    v-if="verifyState != 3"
                  >
                    <!-- <span v-if="!index_id">创建并提交审核</span> -->
                    <span v-if="index_id" :disabled="power['编辑']"
                      >保存并提交审核</span
                    >
                  </button>
                  <button
                    @click="withDraw"
                    class="btn-sm btn btn-primary"
                    type="button"
                    v-if="verifyState == 3"
                  >
                    <!-- <span v-if="!index_id">创建并提交审核</span> -->
                    <span v-if="index_id" :disabled="power['编辑']"
                      >撤销审核</span
                    >
                  </button>
                </div>
                <!-- <div class="bar-handle" v-if="allModify">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    返回
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import Vue from "vue";
// import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import imageUpload from "@/components/imageUpload";
import DatePicker from "vue2-datepicker";
import api from "@/server/api/media";
import { getOperateNum } from "@/util/fun.js";

export default {
  components: {
    Layout,
    DatePicker,
    imageUpload,
  },
  data() {
    return {
      item: {
        userType: "1",
      },
      img1: "",
      img2: "",
      img3: "",
      password: "",
      definePass: "",
      index_id: "",
      allModify: false,
      media: {
        name: "",
        phone: "",
        password: "",
        repeatPassword: "",
        cerName: "", //认证名称
        description: "", //媒体号简介
        operateBody: "", //运营主体
        creditCode: "", //统一社会信用代码/身份证号码
        type: 1, //账号类型 1媒体号2商家
        cerType: 1, //认证类型 1个人2企业
        verifyFlag: 0, //免审开关，1开0关
        avatar: "", //头像地址
        photoAddress: "", //材料文件地址
      },
      adminId: undefined,
      isEdit: false,
      power: "",
      verifyState: 0,
    };
  },

  mounted() {
    this.power = this.utils.currentPower("创作平台-媒体号管理");
    this.index_id = JSON.parse(localStorage.chosedMedia).id;
    this.adminId = JSON.parse(this.cookies.getCookie("user")).id;
    this.isEdit = true;
    this.fetch();
    console.log(this.adminId);
    if (!this.power["编辑"]) {
      this.allModify = true;
    }
  },

  methods: {
    fetch() {
      var params = {
        id: this.index_id,
      };
      if (this.$route.query.userType) {
        params.userType = this.$route.query.userType;
      }
      api.detail(params).then((resp) => {
        console.log("媒体号详情", resp);
        if (resp.code == 0) {
          let obj = {};
          let item = resp.data;
          this.verifyState = item.verifyState;
          obj.name = item.name;
          obj.phone = item.phone;
          obj.cerName = item.cerName;
          obj.description = item.description;
          obj.operateBody = item.operateBody;
          obj.creditCode = item.creditCode;
          this.adminId = item.adminId;
          obj.operateFollowNum = item.operateFollowNum || 0;
          obj.operateLikeNum = item.operateLikeNum || 0;
          if (item.type !== undefined) {
            obj.type = item.type;
          }
          if (item.cerType !== undefined) {
            obj.cerType = item.cerType;
          }
          if (item.verifyFlag !== undefined) {
            obj.verifyFlag = item.verifyFlag;
          }
          obj.avatar = item.avatar;
          obj.photoAddress = item.photoAddress;
          if (item.photoAddress) {
            let arr = item.photoAddress;
            this.img1 = arr[0] ? arr[0] : "";
            this.img2 = arr[1] ? arr[1] : "";
            this.img3 = arr[2] ? arr[2] : "";
          }
          this.media = obj;
          // this.item = resp.data;
          // this.item.definePass = this.item.password;
          // this.item.userType = this.item.userType.toString();
          // this.$refs.avatar.setImageUrl(this.item.avatar);
          // this.$refs.cover.setImageUrl(this.item.background)
        }
      });
    },

    submitPreserve() {
      console.log("保存参数", this.media, this.img1, this.img2, this.img3);
      let params = this.another(this.media);
      params.verifyState = 3;
      // if(params.name)
      // return;
      // let params = JSON.parse(JSON.stringify(this.item));
      if (params.name) {
        if (params.name.length < 2) {
          this.warning("名称最少输入2个字符");
          return;
        }
      } else {
        this.warning("请输入标题");
        return;
      }
      if (!params.phone) {
        this.warning("请输入手机号");
        return;
      } else if (!/^1[3456789]\d{9}$/.test(params.phone)) {
        this.warning("请输入合法的手机号");
        return;
      }
      if (this.index_id) {
        if (params.password) {
          if (params.repeatPassword) {
            if (params.repeatPassword != params.password) {
              this.warning("两次输入密码不一致");
              return;
            }
          } else {
            this.warning("请输入重复密码");
            return;
          }
        } else {
          delete params.password;
        }
        if (params.repeatPassword) {
          if (!params.password) {
            this.warning("请输入密码");
            return;
          }
        }
      } else {
        if (params.password) {
        } else {
          this.warning("请输入密码");
          return;
        }
        if (params.repeatPassword) {
          if (params.repeatPassword != params.password) {
            this.warning("两次输入密码不一致");
            return;
          }
        } else {
          this.warning("请重复密码");
          return;
        }
      }
      /*if (!params.cerName) {
        this.warning("请输入认证名称");
        return;
      }
      if (!params.description) {
        this.warning("请输入媒体号简介");
        return;
      }

      if (!params.operateBody) {
        this.warning("请输入运营主体/姓名");
        return;
      }
      if (!params.creditCode) {
        this.warning("请输入统一社会信用代码/身份证号");
        return;
      }*/
      if (!params.avatar) {
        this.warning("请上传头像");
        return;
      }
      console.log("用户类型", params.cerType, typeof params.cerType);
      if (!params.cerType) {
        this.warning("请选择认证类型");
        return;
      }
      // if (!this.img1 && !this.img2 && !this.img3) {
      //   this.warning("请上传认证材料");
      //   return;
      // }
      let imgArr = [];
      if (this.img1 != "") {
        imgArr.push(this.img1);
      }
      if (this.img2 != "") {
        imgArr.push(this.img2);
      }
      if (this.img3 != "") {
        imgArr.push(this.img3);
      }
      params.photoAddress = imgArr;
      // params.background = this.$refs.cover.getImageUrl()
      // if(!params.background){
      //   this.warning("请上传主页封面图");
      //   return
      // }
      params.operateFollowNum = getOperateNum(
        params.operateFollowNum,
        "follow"
      );
      if (typeof params.operateFollowNum == "string") {
        this.warning(params.operateFollowNum);
        return;
      }
      params.operateLikeNum = getOperateNum(params.operateLikeNum, "like");
      if (typeof params.operateLikeNum == "string") {
        this.warning(params.operateLikeNum);
        return;
      }
      let msg = "";
      if (this.index_id === undefined) {
        msg = "确认创建并提交审核？";
      } else {
        msg = "确认保存并提交审核？";
      }
      this.confirm(msg, () => {
        if (this.index_id !== undefined) {
          params.id = this.index_id;
          params.adminId = this.adminId;
          console.log("保存参数", params);
          api.update(params).then((resp) => {
            // console.log("保存结果", resp);
            if (resp.code == 0) {
              this.success("操作成功！");
              // this.goBack();
              this.fetch();
            } else {
              this.warning(resp.msg);
              console.log(resp);
            }
          });
        } else {
          console.log("保存参数", params);
          api.create(params).then((resp) => {
            // console.log("添加结果", resp);
            if (resp.code == 0) {
              this.success("操作成功！");
              // this.goBack();
            } else {
              this.warning(resp.msg);
              console.log(resp);
            }
          });
        }
      });
    },

    goBack() {
      this.$router.go(-1);
    },
    withDraw() {
      this.confirm("确认撤销审核？", () => {
        let params = {
          id: this.index_id,
          verifyState: 0,
        };
        api.update(params).then((res) => {
          if (res.code === 0) {
            this.success("操作成功！");
            this.fetch();
          } else {
            this.warning(res.message);
          }
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.operate-input-item {
  margin-right: 20px;
}

.operate-input-item span {
  padding-right: 5px;
}

.operate-input-item input {
  width: 120px;
  margin-top: -0.55rem;
}
</style>
